"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGetTenants = void 0;
const react_1 = __importDefault(require("react"));
const moment_1 = __importDefault(require("moment"));
exports.useGetTenants = (getTenantsEndpoint, token, clientId) => {
    const [loading, setLoading] = react_1.default.useState(true);
    const [tenants, setTenants] = react_1.default.useState([]);
    const [error, setError] = react_1.default.useState(null);
    react_1.default.useEffect(() => {
        let status = 0;
        if (token) {
            fetch(getTenantsEndpoint, {
                method: "GET",
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Client-Id": clientId
                }
            })
                .then(resp => {
                status = resp.status;
                return resp;
            })
                .then(resp => resp.json())
                .then(resp => {
                if (status !== 200) {
                    const errors = resp.Errors.General.length > 0
                        ? resp.Errors.General
                        : [
                            {
                                Details: "An error occurred while fetching user tenants"
                            }
                        ];
                    let tenantError = new Error(`${status}|${errors[0].Details}`);
                    tenantError.name = "TenantError";
                    throw tenantError;
                }
                let ts = resp.d.results || [];
                if (ts.length > 1) {
                    ts.sort((a, b) => moment_1.default(b.LastLoggedIn).unix() -
                        moment_1.default(a.LastLoggedIn).unix());
                }
                setTenants(ts || []);
                setLoading(false);
            })
                .catch((err) => {
                const error = err.name === "TenantError"
                    ? err
                    : new Error("An error occurred while fetching user tenants");
                setError(error);
                setTenants([]);
                setLoading(false);
            });
        }
    }, [clientId, getTenantsEndpoint, token]);
    return {
        loading,
        tenants,
        error
    };
};
//# sourceMappingURL=useGetTenants.js.map